export enum EmploymentType {
  EmploymentAgreement = 1,
  MandateAgreement = 2,
  B2BContract = 4,
  TemporaryEmploymentAgreement = 5,
  TemporaryMandateAgreement = 6,
}

export const TEMPORARY_EMPLOYMENT_TYPES_NUMS = new Set([Number(EmploymentType.TemporaryEmploymentAgreement), Number(EmploymentType.TemporaryMandateAgreement)]);
